// extracted by mini-css-extract-plugin
export var header = "_v3-1";
export var maskBottom = "_v3-6";
export var maskMiddle = "_v3-7";
export var maskTop = "_v3-5";
export var root = "_v3-0";
export var scrollDownButton = "_v3-3";
export var scrollDownButtonHidden = "_v3-4";
export var viewport = "_v3-2";